import * as requestsAccountingReducer from '../../../../redux/modules/requests-accounting';

const mapStateToProps = state => ({
  selectedRequests: state.requestsForAccounting.selectedRequests,
});

const mapDispatchToProps = {
  ...requestsAccountingReducer
};

export default [mapStateToProps, mapDispatchToProps];



// WEBPACK FOOTER //
// ./src/containers/accounting/table/row/index.js